import $ from "jquery";
import PageBase from "./PageBase";
import { CalendarApp, ModalCalendarApp } from "../modules";


export default class AccessApp extends PageBase {
  constructor() {
    super();
  }

  init() {
    super.init();

    const dispatcher = this.initTopImage();
    dispatcher.bind("init", () => {
      this.initFadeAnimation();
    });

    this.calendar = new CalendarApp();
    this.calendar.dispatcher.bind("init", () => {});
    this.calendar.init();

    this.modalCalendar = new ModalCalendarApp();
    this.modalCalendar.dispatcher.bind("init", () => {});
    this.modalCalendar.init();

    this.$maps = $("#js-subMap").find(".content");
    this.$maps.addClass("hide");
    this.$tabs = $("#js-tabMenu").find(".tabMenu__item");

    this.$tabs.click((e) => {
       const index = parseInt($(e.target).data("index"));
       this.setMap(index);
    });

    this.setMap(0);
    this.initAnchor();
    this.initHeaderColorChange();
  }

  initAnchor() {
    if (/^#calendar/.test(location.hash)) {
      const y = $("#js-calendar-anchor").offset().top - 20;
      setTimeout(() => {
        $(window).scrollTop(y);
      }, 30);
    }
  }

  setMap(index) {
    if (this.$current) {
      this.$current.addClass("hide");
    }

    if (this.$currentTab) {
      this.$currentTab.removeClass("selected");
    }

    const $content = $(this.$maps[index]);
    $content.removeClass("hide");

    const $tab = $(this.$tabs[index]);
    $tab.addClass("selected");

    this.$current = $content;
    this.$currentTab = $tab;
  }
}



// WEBPACK FOOTER //
// ./src/js/apps/pages/AccessApp.js